<div class="align-items-center fixed flex h-full justify-content-center w-full">
  <div class="w-25rem">
    <form [formGroup]="form" (ngSubmit)="signWithEmailAndPassword()">
      <div class="field">
        <label for="email">E-mail</label>
        <input class="w-full" [formControlName]="'email'" id="email" pInputText pSize="large" type="email" />
      </div>
      <div class="field">
        <label for="senha">Senha</label>
        <input class="w-full" [formControlName]="'senha'" id="senha" pInputText pSize="large" type="password" />
      </div>
      <button class="w-full" [disabled]="!form.valid" pButton type="submit">Entrar</button>
    </form>
  </div>
</div>
